<template>
  <my-form :readonly="!canUpdate" ref="form" :report-success="false" :force-edit-mode="canUpdate" :start-in-edit-mode="canUpdate">
    <template v-slot:default="{ invalid, valid, errors, formIsReadonly }">
      <p class="text-info"><strong>Reimbursement:</strong> the action of repaying a person who has spent or lost money</p>
      <p class="text-info">Example: a cleaner receives reimbursement because the client is out of town and asked the cleaner to buy towels & toliet paper for new guests arriving.</p>
      <div v-if="canUpdate" class="row">
        <template v-if="requirePassword">
          <div class="col-11 mb-4">
            <my-text-input
              label="Password"
              v-model="password"
              name="password"
              description="You can get the password from your service area admin"
              rules="required"
            ></my-text-input>
          </div>
        </template>
        <div class="col-7">
          <my-text-input
            v-model="description"
            name="description"
            :hide-label="true"
            placeholder="Description"
            rules="required|min:5"
          />
        </div>
        <div class="col-5 blue-text">
          <amount-field v-model="amount" placeholder="Amount" :hide-label="true" :format-as-currency="true" rules="required|min:1|min_value:0" />
        </div>
        <p class="col-12 text-info"><strong>The whole amount goes to cleaner(s), paid by the client</strong></p>
      </div>
      <div v-else class="text-danger text-center"><strong>Already has an invoiced reimbursement</strong></div>
    </template>
    <template v-slot:edit-buttons="{ validated, invalid }">
      <b-button class="btn btn-default btn-primary" :disabled="invalid && validated" variant="primary" type="submit">Submit</b-button>
      <b-button class="btn btn-default" variant="danger" @click="remove">Remove</b-button>
    </template>
  </my-form>
</template>
<script>
import Spinner from '@/shared/spinner.vue'
import MyForm from '@/shared/base_form.vue'
import MyTextInput from '@/shared/inputs/base.vue'
import AmountField from '@/shared/fields/amount.vue'
import api from '@/admins/api'
import { formatCurrency } from '@/utils'

export default {
  props: {
    eventId: {
      type: Number
    },
  },
  components: { Spinner, MyForm, MyTextInput, AmountField },
  data() {
    return {
      amountCents: 0,
      description: null,
      password: null,
      requirePassword: false,
      canUpdate: false,
      error: null
    }
  },
  computed: {
    amount: {
      get() {
        return this.amountCents * 0.01
      },
      set(v) {
        this.amountCents = Math.round(v * 100)
      }
    },
    formattedAmount() {
      return formatCurrency(this.amount)
    },
    params() {
      let params = { amount_cents: this.amountCents, description: this.description }
      if (this.requirePassword) {
        params.password = this.password
      }
      return params
    }
  },
  methods: {
    getReimbursement() {
      this.$emit('update:loading', true)
      api.getVisitReimbursement(this.eventId).then(response => {
        this.amountCents = response.data.amount_cents
        this.description = response.data.description
        this.requirePassword = response.data.require_password
        this.canUpdate = response.data.can_update
        this.$emit('update:loading', false)
      }, errors => {
        this.$emit('update:loading', false)
        this.$flasher.errors(errors.response.data.errors)
      })
    },
    remove() {
      api.removeVisitReimbursement(this.eventId).then(() => {
        this.$emit('update:loading', false)
        this.$emit('reload-event')
        resolve()
      })
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$emit('update:loading', true)
        api.updateVisitReimbursement(this.eventId, this.params).then(() => {
          this.$emit('update:loading', false)
          this.$emit('reload-event')
          resolve()
        }, errors => {
          this.$emit('update:loading', false)
          reject(errors)
        }).catch(() => {
          this.$emit('update:loading', false)
          reject(false)
        })
      })
    }
  },
  mounted() {
    this.getReimbursement()
  }
}
</script>
